import React from 'react';
import { ExternalLink, Github, Search, ShoppingCart } from 'lucide-react';

function App() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      {/* Top Navigation */}
      <nav className="border-b border-gray-200 bg-white sticky top-0 z-50">
        <div className="w-full px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center font-bold text-center text-[#000000] bg-[#FFFFFF] text-xs">UCP

              </div>
              <span className="font-semibold text-gray-900">Universal Commerce Protocol (UCP)</span>
            </div>
            
          </div>
          <div className="flex items-center gap-4">
            







            <a
              href="https://github.com/Universal-Commerce-Protocol/ucp"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900">

              <Github size={20} />
              <span className="font-medium">UCP on GitHub</span>
            </a>
          </div>
        </div>
      </nav>

      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 border-r border-gray-200 min-h-screen p-6 sticky top-16 self-start">
          <div className="space-y-1">
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
              Universal Commerce Protocol (UCP)
            </div>
            <a href="#home" className="block px-3 py-2 text-sm text-blue-600 bg-blue-50 rounded-md font-medium">
              Home
            </a>
            <a href="#concepts" className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md">
              Core Concepts
            </a>
            <a href="#playground" className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md">
              Playground
            </a>
            <a href="#specification" className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md flex items-center justify-between">
              <span>Specification</span>
              <span className="text-gray-400">›</span>
            </a>
            <a href="#api" className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md">
              UCP and AP2
            </a>
            <a href="#roadmap" className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md">
              Roadmap
            </a>
          </div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 max-w-5xl px-16 py-16">
          {/* Domain Sale Notice */}
          <div className="mb-12 p-6 rounded-lg bg-amber-50 border-2 border-amber-200">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-amber-400 rounded-lg flex items-center justify-center flex-shrink-0">
                <ShoppingCart size={20} className="text-white" />
              </div>
              <div>
                <h2 className="text-xl font-bold mb-2 text-amber-900">Premium Domain For Sale</h2>
                <p className="text-gray-700 mb-3">
                  <span className="font-semibold">ucp.it.com</span> is now available for purchase
                </p>
                <p className="text-gray-600 text-sm mb-3">
                  Secure this premium domain aligned with Google Chrome's Universal Commerce Protocol standard. 
                  Perfect for businesses, developers, or investors.
                </p>
                <div className="flex flex-wrap gap-2 text-xs">
                  <span className="px-3 py-1.5 bg-white rounded-full border border-amber-300 text-amber-800">
                    ✓ Memorable & Short
                  </span>
                  <span className="px-3 py-1.5 bg-white rounded-full border border-amber-300 text-amber-800">
                    ✓ Industry Relevant
                  </span>
                  <span className="px-3 py-1.5 bg-white rounded-full border border-amber-300 text-amber-800">
                    ✓ Future-Proof Investment
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Hero Section */}
          <div className="flex items-start justify-between mb-16">
            <div className="flex-1 pr-12">
              <h1 className="text-6xl font-normal leading-tight mb-6">
                Universal<br />
                Commerce<br />
                Protocol
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                The common language for platforms, agents and businesses.
              </p>
              <p className="text-gray-700 leading-relaxed">
                UCP defines building blocks for agentic commerce—from discovering and buying to post purchase experiences—allowing the ecosystem to interoperate through one standard, without custom builds.
              </p>
            </div>
            
            {/* UCP Logo */}
            <div className="flex-shrink-0">
              







            </div>
          </div>

          {/* Action Cards */}
          <div className="grid md:grid-cols-2 gap-6 mb-20">
            <div className="bg-gray-50 rounded-lg p-8 border border-gray-200">
              <h3 className="text-xl font-semibold mb-2">Learn</h3>
              <p className="text-gray-600 text-sm mb-6">
                Protocol overview, core concepts, and design principles
              </p>
              <a
                href="https://ucp.dev"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-white border-2 border-gray-900 rounded-full text-sm font-medium hover:bg-gray-900 hover:text-white transition-colors">

                Read the docs
              </a>
            </div>

            <div className="bg-gray-50 rounded-lg p-8 border border-gray-200">
              <h3 className="text-xl font-semibold mb-2">Implement</h3>
              <p className="text-gray-600 text-sm mb-6">
                GitHub repo, technical spec, SDKs, and reference implementations
              </p>
              <a
                href="https://github.com/Universal-Commerce-Protocol/ucp"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-white border-2 border-gray-900 rounded-full text-sm font-medium hover:bg-gray-900 hover:text-white transition-colors">

                View on GitHub
                <ExternalLink size={14} />
              </a>
            </div>
          </div>

          {/* Industry Leaders Section */}
          <div className="text-center mb-16">
            <h2 className="text-4xl font-normal mb-6">
              Co-developed and adopted by industry leaders
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto mb-12">
              UCP was built by the industry, for the industry to solve for fragmented commerce journeys that lead to abandoned carts and frustrated shoppers, and enable agentic commerce.
            </p>

            {/* Company Logos */}
            <div className="grid grid-cols-3 gap-x-16 gap-y-8 items-center justify-items-center max-w-3xl mx-auto">
              <img src="https://cdn.worldvectorlogo.com/logos/google-6.svg" alt="Google" className="h-10 w-auto"></img>
              <img src="https://cdn.worldvectorlogo.com/logos/shopify-2.svg" alt="Shopify" className="h-10 w-auto"></img>
              <img src="https://cdn.worldvectorlogo.com/logos/etsy.svg" alt="Etsy" className="h-10 w-auto"></img>
              <img src="https://assets.wfcdn.com/dm/image/3aeb2145-9e7e-488e-a17c-1c8f2ac25e02/Wayfair_US_Logo_Purple_Horizontal.png" alt="Wayfair" className="h-10 w-auto"></img>
              <img src="https://cdn.worldvectorlogo.com/logos/target.svg" alt="Target" className="h-10 w-auto"></img>
              <img src="https://cdn.brandfetch.io/idoGsFQrHx/theme/dark/logo.svg?c=1bxid64Mup7aczewSAYMX&t=1761183718064" alt="Walmart" className="h-10 w-auto pl-[45px] pr-[45px]"></img>
            </div>
          </div>

          {/* About Domain */}
          <div className="bg-gray-50 rounded-lg p-8 border border-gray-200 mt-20">
            <h2 className="text-2xl font-semibold mb-4">About This Domain</h2>
            <p className="text-gray-700 mb-4">
              This domain (<strong>ucp.it.com</strong>) was registered to capitalize on the growing adoption of the 
              Universal Commerce Protocol standard. With Google Chrome's announced support for UCP, this represents 
              a strategic investment opportunity in the future of web commerce infrastructure.
            </p>
            <p className="text-sm font-bold text-[#22C55E]">Status: Available for purchase | Contact for inquiries | Email: arenick4work@gmail.com

            </p>
          </div>
        </main>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-20">
        <div className="max-w-7xl mx-auto px-6 py-8 text-center text-gray-500 text-sm">
          <p>© 2024 ucp.it.com - Premium Domain Investment</p>
          <p className="mt-2">
            Universal Commerce Protocol is an open standard. This site is not officially affiliated with Google or UCP.dev
          </p>
        </div>
      </footer>
    </div>);

}

export default App;